import { defineMessages } from 'react-intl';

export default defineMessages({
  Продовжити: {
    id: 'sell_auto:form_phone:continue:cta',
    defaultMessage: 'Продовжити',
  },
});
